export default __webpack_public_path__ + "static/media/Book-3.a1d91e52.jpg";